<button
  (click)="this.openInfoPageModal()"
  [disabled]="cta.disable"
  class="btn lead-btn d-flex justify-content-center btn-primary flex-grow-1"
>
  {{cta.name}}
</button>
